// extracted by mini-css-extract-plugin
export var details = "_dn-0";
export var inspectorPopover = "_dn-1";